import { render, staticRenderFns } from "./examImg.vue?vue&type=template&id=bd94efe0&scoped=true"
import script from "./examImg.vue?vue&type=script&lang=js"
export * from "./examImg.vue?vue&type=script&lang=js"
import style0 from "./examImg.vue?vue&type=style&index=0&id=bd94efe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd94efe0",
  null
  
)

export default component.exports